if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);
            this.handleStaleCart(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      const staleAction = this.errorMessageWrapper.querySelector('.product-form__error-action');
      if (staleAction) staleAction.remove();

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    // Shopify answered "already sold out" for a variant this page just
    // rendered as purchasable (the button said "Add to cart", so Liquid saw
    // variant.available == true). That mismatch means the shopper's saved
    // cart is out of step with the storefront — e.g. a cart created before
    // a wholesale buyer's catalog/market assignment, or one still holding
    // lines from since-replaced products. Offer a one-click clear + retry
    // instead of leaving them stuck on a misleading "sold out".
    handleStaleCart(description) {
      if (this.hideErrors || !this.errorMessageWrapper) return;
      const hint = this.dataset.staleCartHint;
      if (!hint) return;
      if (!/sold out/i.test(description || '')) return;
      if (this.submitButton.hasAttribute('disabled')) return;
      if (this.errorMessageWrapper.querySelector('.product-form__error-action')) return;

      const note = document.createElement('div');
      note.className = 'product-form__error-action';

      const text = document.createElement('span');
      text.textContent = this.retriedAfterClear ? (this.dataset.staleCartRetryFailed || hint) : hint;
      note.appendChild(text);

      if (!this.retriedAfterClear) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'link product-form__error-action-button';
        btn.textContent = this.dataset.staleCartAction || 'Clear cart and try again';
        btn.addEventListener('click', () => {
          btn.disabled = true;
          const clearUrl = (window.routes && window.routes.cart_clear_url) || '/cart/clear.js';
          fetch(clearUrl, { method: 'POST', headers: { Accept: 'application/json' } })
            .then(() => {
              this.retriedAfterClear = true;
              this.error = false;
              this.submitButton.removeAttribute('aria-disabled');
              if (this.form.requestSubmit) {
                this.form.requestSubmit();
              } else {
                this.form.dispatchEvent(new Event('submit', { cancelable: true }));
              }
            })
            .catch((e) => {
              console.error(e);
              btn.disabled = false;
            });
        });
        note.appendChild(btn);
      }

      this.errorMessageWrapper.appendChild(note);
    }
  });
}
